'use client';
import { FilterListPayload, PlpFilterQueryParams } from 'src/types/CarFilters.types';
import { SearchAlertTileLowResults } from '../SearchAlertTile/SearchAlertTileLowResults';
import { SearchAlertTileNoResults } from '../SearchAlertTile/SearchAlertTileNoResults';
import { SearchAlertToggleProvider } from '../SearchAlertToggle/SearchAlertToggleProvider';
import { FC } from 'react';
import { SearchAlertToggle } from '../SearchAlertToggle/SearchAlertToggle';

type Props = {
  filtersList: FilterListPayload;
  filterParams?: PlpFilterQueryParams;
  sku?: string;
  placement: 'tile' | 'page-top';
};

export const ResultsSearchAlertToggle: FC<Props> = ({ filterParams, filtersList, sku, placement }: Props) => {
  const getToggleComponent = () => {
    if (placement === 'tile') {
      return sku ? SearchAlertTileLowResults : SearchAlertTileNoResults;
    }
    return SearchAlertToggle;
  };

  return (
    <SearchAlertToggleProvider
      filtersList={filtersList}
      filters={filterParams}
      Component={getToggleComponent()}
      placement={placement}
    />
  );
};
